import caching from "@/plugins/caching/caching";

// Also used by the OIDC bootstrap, which deletes the cache before Vue (and this plugin) exists
export const CACHE_DB_NAME = 'cachingDB'

export default {
    install(Vue) {
        Vue.prototype.$caching = new caching(CACHE_DB_NAME);
    }
}
